import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { TemplateService } from '../services/template.service';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { AddTemplateComponent } from './add-template/add-template.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-templates',
    templateUrl: './templates.component.html',
    styleUrls: ['./templates.component.scss'],
    standalone: false
})
export class TemplatesComponent implements OnInit, AfterViewInit {

  IsLoading = false;
  IsUpdating = false;
  public dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = [ 'nombre', 'action'];

  constructor(
    private templateService: TemplateService,
    public dialog: MatDialog,
    private sharedService: SharedService) { }

  ngOnInit(): void {
    this.getTemplates();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  addNewTemplate(): void {
    const dialogRef = this.dialog.open(AddTemplateComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.saved.subscribe(() => {
      this.getTemplates();
    });
  }

  editExistingTemplate(template: any, file: string): void {
    const dialogRef = this.dialog.open(AddTemplateComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.IsUpdate = this.IsUpdating;
    dialogRef.componentInstance.Template = template;
    dialogRef.componentInstance.TemplateFile = file;

    dialogRef.componentInstance.saved.subscribe(() => {
      this.getTemplates();
    });

    dialogRef.afterClosed().subscribe(() => {
      this.IsUpdating = false;
    });
  }

  getTemplates(): void {
    this.templateService.getTemplates()
      .subscribe(res => {
        if (res.code === 0) {
          this.dataSource.data = res.result;
          this.dataSource.paginator = this.paginator;
        }
      }, err => {
        this.sharedService.ShowSnackBar('Error al cargar la lista de plantillas', 'Okay', 2500);
        console.error(err);
      });
  }

  confirmDialog(template): void {
    const message = `¿Seguro que quieres hacer esto?`;

    const dialogData = new ConfirmDialogModel('Confirmar acción', message);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this.templateService.deleteTemplate(template.plantillaId).subscribe(res => {
          this.getTemplates();
          this.sharedService.ShowSnackBar('Borrado exitosamente', 'Okay', 2500);
        });
      }
    });
  }

  editTemplate(template): void {
    this.IsUpdating = true;
    this.templateService.downloadTemplate(template.plantillaId).subscribe(res => {
      if (res.code === 0) {
        const file = res.result.file;
        this.editExistingTemplate(template, file);
      } else {
        this.sharedService.ShowSnackBar('No se encontró la plantilla', '', 2000);
        this.editExistingTemplate(template, '');
      }
    });
  }

  downloadTemplate(template): void {
    this.templateService.downloadTemplate(template.plantillaId).subscribe(res => {
      if (res.code === 0) {
        const file = res.result.file;
        const fileName = res.result.fileName;
        const link = document.createElement('a');
        link.setAttribute('type', 'hidden');
        link.href = 'data:application/octet-stream;base64,' + file;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        this.sharedService.ShowSnackBar('No se encontró la plantilla', '', 2000);
        console.error(res.message);
      }
    }, error => {
      this.sharedService.ShowSnackBar('No se encontró la plantilla', 'Okay', 2000);
      console.error(error);
    });
  }

}
